/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ChatHistory } from './chatHistory';

export type GenericApiResponseChatHistoryData = ChatHistory | null;
